import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
const environment = (import.meta.env.VITE_SENTRY_ENVIRONMENT as string) || import.meta.env.MODE || "development";
const isProduction = environment === "production";

if (!import.meta.env.DEV) {
  Sentry.init({
    dsn,
    environment,
    sendDefaultPii: false,
    tracesSampleRate: isProduction ? 0.1 : 1.0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: [
      "Network request failed",
      "Failed to fetch",
      "NetworkError",
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications",
    ],
    beforeSend(event) {
      const frames = event.exception?.values?.[0]?.stacktrace?.frames ?? [];
      if (frames.some((f) => f.filename?.includes("chrome-extension://") || f.filename?.includes("moz-extension://"))) {
        return null;
      }
      return event;
    },
  });
}

export { Sentry };
